export enum FanTokenOfferingLimits {
	InsufficientBalance = 'InsufficientBalance',
	OverCap = 'OverCap'
}
